import { useRouter } from '../../lib/router'
import { HomePage } from './HomePage'
import { PricingPage } from './PricingPage'
import { AboutPage } from './AboutPage'
import { FAQPage } from './FAQPage'
import { ContactPage } from './ContactPage'
import { TermsPage } from './TermsPage'
import { PrivacyPage } from './PrivacyPage'
import { FunnelPage } from './FunnelPage'
import { WorkshopGuidePage } from './WorkshopGuidePage'

export function MarketingPages() {
  const { path } = useRouter()
  switch (path) {
    case '/': return <HomePage />
    case '/pricing': return <PricingPage />
    case '/about': return <AboutPage />
    case '/faq': return <FAQPage />
    case '/contact': return <ContactPage />
    case '/terms': return <TermsPage />
    case '/privacy': return <PrivacyPage />
    case '/workshop-management-software': return <FunnelPage kind="workshop" />
    case '/whatsapp-workshop-management': return <FunnelPage kind="whatsapp" />
    case '/digital-vehicle-inspection-software': return <FunnelPage kind="dvi" />
    case '/workshop-payment-links': return <FunnelPage kind="payments" />
    case '/workshop-accounting-sync': return <FunnelPage kind="accounting" />
    case '/digital-job-cards': return <WorkshopGuidePage kind="job-cards" />
    case '/workshop-load-shedding': return <WorkshopGuidePage kind="connectivity" />
    default: return <main><h1>Page not found</h1><a href="/">Return to AutoAxxiz</a></main>
  }
}
